import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import EmailIcon from '@material-ui/icons/Email';

class EmailDialog extends Component {
    constructor(props){
        super(props)
        this.state = {
            open: false,
            email: "",
            emailBody: "Thanks for taking our assessment"
        }
    }

    componentDidMount(){
        if(this.props.userEmail && this.props.userEmail.length){
            this.setState({email: this.props.userEmail})
        }
        if(this.props.content && this.props.length){
            var bodyString = "<div><h2>" + this.props.content[0].ComponentContent.Title + "</h2></div>"
            this.setState({
                emailBody: this.props.content[0].ComponentContent.Title
            })
        }
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleUpdateEmail = (ev) => {
        if(ev){
            this.setState({
            email: ev.target.value
            })
        }
    }

    handleSubmit = () => {
        console.log('submit')

        const org_guid = new URLSearchParams(window.location.search).get('org')

    fetch("../../WsWebServicePlatform/Participant/SendReport/" + org_guid + "/" + this.state.email + "/1/", {
        method: "POST",
        headers:{'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}
        })
        .then(response => response.json())
        .then(() => {
            this.setState({
                open: false
            })
        })
    }

  render(){
      return (
    <div>
      <IconButton color="primary" onClick={() => this.handleClickOpen()}>
        <EmailIcon color="primary"/>
      </IconButton>
      <Dialog open={this.state.open} onClose={() =>this.handleClose()} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Email me this report</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Send yourself a copy of this report for your own records or to share it with a doctor later
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            value={this.state.email}
            onChange={this.handleUpdateEmail}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.handleClose()}>
            Cancel
          </Button>
          <Button onClick={() => this.handleSubmit()} color="primary" variant="contained">
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
  }
  
}

export default EmailDialog